import { render, staticRenderFns } from "./SuggestedFilters.vue?vue&type=template&id=0945ff98&scoped=true&"
import script from "./SuggestedFilters.vue?vue&type=script&lang=js&"
export * from "./SuggestedFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0945ff98",
  null
  
)

export default component.exports